import { Spinner } from "@nextui-org/react";
import React, { useEffect, useState, useRef, useCallback } from "react";

const InfiniteScroll = ({ loadMore, hasMore, threshold = 0.5, children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const isLoadingRef = useRef(false);
  const observerRef = useRef(null);
  const sentinelRef = useRef(null);
  const hasMoreRef = useRef(hasMore);
  const loadMoreRef = useRef(loadMore);

  // Keep refs in sync with latest props
  hasMoreRef.current = hasMore;
  loadMoreRef.current = loadMore;

  const handleIntersection = useCallback((entries) => {
    const [entry] = entries;
    if (entry.isIntersecting && hasMoreRef.current && !isLoadingRef.current) {
      isLoadingRef.current = true;
      setIsLoading(true);
      Promise.resolve(loadMoreRef.current())
        .then(() => {
          isLoadingRef.current = false;
          setIsLoading(false);
        })
        .catch(() => {
          isLoadingRef.current = false;
          setIsLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: threshold,
    });
    observerRef.current = observer;

    if (sentinelRef.current) {
      observer.observe(sentinelRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [handleIntersection, threshold]);

  return (
    <>
      {children}
      <div
        ref={sentinelRef}
        style={{
          height: "1px",
          background: "transparent",
        }}
      ></div>
      {isLoading && (
        <div className="w-full flex justify-center items-center">
          <Spinner color="danger" />
        </div>
      )}
    </>
  );
};

export default InfiniteScroll;
